import { render, staticRenderFns } from "./actions-modal.vue?vue&type=template&id=71f8b7ca&"
import script from "./actions-modal.vue?vue&type=script&lang=js&"
export * from "./actions-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports